@if (initialized && importDto) {
    <div class="surface-card p-3 border-round">
        <div class="grid align-items-center">

            <!-- Partner -->
            <div class="col-12 md:col-6">
                <div class="flex flex-column gap-1">
                    <span class="text-sm text-color-secondary">Partner</span>
                    <p-button
                            [label]="importDto.hgPartnerDtoName || 'Unbekannter Partner'"
                            icon="fa-regular fa-handshake"
                            severity="secondary"
                            [text]="true"
                            [disabled]="!importDto.hgPartnerDtoId"
                            (onClick)="handleOpenPartner()">
                    </p-button>
                </div>
            </div>

            <!-- Status -->
            <div class="col-12 md:col-6">
                <div class="flex flex-column gap-1 md:align-items-end">
                    <span class="text-sm text-color-secondary">Status</span>
                    @switch (importDto.status) {
                        @case (HgImportStatusInternalEnum.NEW) {
                            <p-tag severity="info" value="Neu"></p-tag>
                        }
                        @case (HgImportStatusInternalEnum.PROCESSING) {
                            <p-tag severity="warn" value="In Bearbeitung"></p-tag>
                        }
                        @case (HgImportStatusInternalEnum.INGESTION) {
                            <p-tag severity="warn" value="Datenaufnahme"></p-tag>
                        }
                        @case (HgImportStatusInternalEnum.DELEGATED) {
                            <p-tag severity="info" value="Delegiert"></p-tag>
                        }
                        @case (HgImportStatusInternalEnum.COMPLETED) {
                            <p-tag severity="success" value="Abgeschlossen"></p-tag>
                        }
                        @case (HgImportStatusInternalEnum.ERROR) {
                            <p-tag severity="danger" value="Fehler"></p-tag>
                        }
                    }
                </div>
            </div>

            <!-- Erstellt am -->
            <div class="col-12 md:col-6">
                <div class="flex flex-column gap-1">
                    <span class="text-sm text-color-secondary">Erstellt am</span>
                    <span class="font-medium">
                        @if (importDto.createdDate) {
                            {{ importDto.createdDate | date: 'dd.MM.yyyy HH:mm' }}
                        } @else {
                            &mdash;
                        }
                    </span>
                </div>
            </div>

            <!-- Erstellt von -->
            <div class="col-12 md:col-6">
                <div class="flex flex-column gap-1 md:align-items-end">
                    <span class="text-sm text-color-secondary">Erstellt von</span>
                    <span class="font-medium">{{ importDto.createdBy || '&mdash;' }}</span>
                </div>
            </div>

            <!-- Dokument-Name (Info-Zeile) -->
            @if (importDto.dmDocumentDtoName) {
                <div class="col-12">
                    <div class="flex align-items-center gap-2 text-color-secondary">
                        <i class="fa-regular fa-file-lines"></i>
                        <span class="text-sm">{{ importDto.dmDocumentDtoName }}</span>
                    </div>
                </div>
            }
        </div>
    </div>
}
